import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card stats-card is-two-thirds column m-auto mt-10",
  style: { 'min-height': '200px' }
}
const _hoisted_2 = { class: "level is-fullwidth pb-0" }
const _hoisted_3 = { class: "level-item has-text-centered" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 0,
  class: "heading"
}
const _hoisted_6 = {
  key: 1,
  class: "heading"
}
const _hoisted_7 = { class: "level-item has-text-centered" }
const _hoisted_8 = {
  key: 0,
  class: "title"
}
const _hoisted_9 = {
  key: 1,
  class: "title has-text-muted"
}
const _hoisted_10 = { class: "level-item has-text-centered" }
const _hoisted_11 = {
  key: 0,
  class: "title"
}
const _hoisted_12 = {
  key: 1,
  class: "title has-text-muted"
}
const _hoisted_13 = {
  key: 0,
  class: "level-item has-text-centered"
}
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "has-text-centered has-text-weight-bold mb-5"
}
const _hoisted_17 = {
  key: 2,
  class: "percentage-bar"
}
const _hoisted_18 = ["id", "onMouseenter", "onMouseleave", "aria-label"]
const _hoisted_19 = ["id"]
const _hoisted_20 = { class: "tooltip-inner" }

import Rails from "@rails/ujs";
import { startCase } from "lodash-es";
import { computed, onBeforeMount, ref } from "vue";

type Statistics = {
  games_count: number;
  average_rating: number | null;
  percent_completed: number | null;
  total_days_played: number | null;
  completion_statuses: {
    unplayed: number;
    in_progress: number;
    dropped: number;
    completed: number;
    fully_completed: number;
    not_applicable: number;
    paused: number;
    unknown: number;
  } | null;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'user-statistics',
  props: {
    userId: {}
  },
  setup(__props: any) {

const props = __props;
const statistics = ref<Statistics | null>(null);
const isLoading = ref(true);

const getStatistics = () => {
  fetch(`/users/${props.userId}/statistics.json`)
    .then((response) => {
      return response.json();
    })
    .then((stats) => {
      statistics.value = stats;
      isLoading.value = false;
    });
};

const showPopover = (i: number) => {
  // Do not display the popovers if the browser doesn't support anchoring.
  // TODO: Remove this check when Firefox fully supports CSS Anchoring.
  if (!CSS.supports("anchor-name: none") || !CSS.supports("position-anchor: auto")) {
    return;
  }
  const pop = document.getElementById(`popover-${i}`);
  const status = document.getElementById(`completion-status-${i}`);
  if (pop && status) {
    status.style.anchorName = `--popover-anchor`;
    pop.showPopover?.();
  }
};

const hidePopover = (i: number) => {
  // Do not display the popovers if the browser doesn't support anchoring.
  if (!CSS.supports("anchor-name: none") || !CSS.supports("position-anchor: auto")) {
    return;
  }
  const pop = document.getElementById(`popover-${i}`);
  const status = document.getElementById(`completion-status-${i}`);
  if (pop && status) {
    status.style.anchorName = "none";
    pop.hidePopover?.();
  }
};

const completionStatusesCount = computed(() => {
  if (statistics.value) {
    const values = Object.values(statistics.value.completion_statuses ?? {});
    return values.reduce((accumulator: number, currentValue: number) => {
      return accumulator + currentValue;
    });
  } else {
    return null;
  }
});

const averageRatingExists = computed(() => {
  return statistics.value?.average_rating !== null;
});

const completionRateExists = computed(() => {
  return statistics.value?.completion_statuses !== null;
});

const daysPlayedIsPositive = computed(() => {
  return (statistics.value?.total_days_played ?? 0) > 0;
});

const gamesCountIsPositive = computed(() => {
  return (statistics.value?.games_count ?? 0) > 0;
});

onBeforeMount(() => getStatistics());

return (_ctx: any,_cache: any) => {
  return (gamesCountIsPositive.value && !isLoading.value && statistics.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(statistics.value.games_count), 1),
              (statistics.value.games_count === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Game"))
                : (_openBlock(), _createElementBlock("p", _hoisted_6, "Games"))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              (completionRateExists.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(statistics.value.percent_completed) + "%", 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_9, "N/A%")),
              _cache[0] || (_cache[0] = _createElementVNode("p", { class: "heading" }, "Completed", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              (averageRatingExists.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(statistics.value.average_rating), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_12, "N/A")),
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "heading" }, "Average Rating", -1))
            ])
          ]),
          (daysPlayedIsPositive.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_14, _toDisplayString(statistics.value.total_days_played), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("p", { class: "heading" }, "Days Played", -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (completionRateExists.value)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_15))
          : _createCommentVNode("", true),
        (completionRateExists.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Completion "))
          : _createCommentVNode("", true),
        (completionRateExists.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statistics.value.completion_statuses, (v, k, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: k,
                  id: `completion-status-${i}`,
                  class: _normalizeClass(['percentage-bar-portion', `color-${i + 1}`]),
                  style: _normalizeStyle({
          'max-width': (completionStatusesCount.value ? (v / completionStatusesCount.value) * 100 : 0) + '%'
        }),
                  onMouseenter: ($event: any) => (showPopover(i)),
                  onMouseleave: ($event: any) => (hidePopover(i)),
                  "aria-label": `${_unref(startCase)(k)}: ${v}`
                }, [
                  _createElementVNode("div", {
                    id: `popover-${i}`,
                    class: "tooltip",
                    popover: "auto",
                    "data-tooltip-placement": "top"
                  }, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tooltip-arrow" }, null, -1)),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(startCase)(k)) + " (" + _toDisplayString(v) + ")", 1)
                  ], 8, _hoisted_19)
                ], 46, _hoisted_18))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})